module.exports = "https://s91588.cdn.ngenix.net/microcredits-frontend/_next/static/images/appSheetFourthImage-3b1aeb784256f2a18cbb2a9387ffa86e.png";